import { InterimSummaryExpertSummary } from '@packages/core-shared';

export const defaultExpertSummary: InterimSummaryExpertSummary = {
  motivation: '',
};
